import { useCallback, useState } from 'react'

const useChartFilters = (setChartParams) => {
  const [params, setParams] = useState({})

  // biome-ignore lint/correctness/useExhaustiveDependencies: todo: re-evaluate dependencies
  const onApply = useCallback(() => {
    setChartParams(params)
  }, [params])

  // biome-ignore lint/correctness/useExhaustiveDependencies: todo: re-evaluate dependencies
  const onReset = useCallback(() => {
    setParams({})
    setChartParams({})
  }, [params])

  const onChange = useCallback((name, values) => {
    setParams((prevParams) => ({ ...prevParams, [name]: values }))
  }, [])

  return [onApply, onReset, onChange, params]
}

export default useChartFilters
